import * as React         from 'react';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';
import { NavLink }        from 'react-router-dom';

import RenderButton            from '../../../buttons/base/RenderButton';
import { RenderCheckboxField } from '../../../fields/redux/RenderCheckboxField';
import { RenderPhoneField }    from '../../../fields/redux/RenderPhoneField';
import { RenderTextField }     from '../../../fields/redux/RenderTextField';
import { useCommon }           from '../../../../providers/common';
import { validate }            from '../../actions/validate';

const NotificationForm = (props) => {
  const { t } = useTranslation();

  const {
          closeModal,
          handleSubmit,
          submitForm,
          valid,
        } = props;

  const common = useCommon();

  return (
    <form
      className={'notification_form'}
      method={'post'}
      name={'NotificationForm'}
      noValidate={true}
      onSubmit={(event) => submitForm(event, handleSubmit, valid)}
    >
      <RenderTextField
        autoComplete={'off'}
        placeholder={`${t('client_name')}`}
        name={'name'}
        required
      />
      <RenderPhoneField
        autoComplete={'off'}
        placeholder={`${t('client_phone')}`}
        name={'phone'}
        required
      />
      <div className={'agreement'}>
        <RenderCheckboxField
          autoComplete={'off'}
          label={
            <span className={'agreement_wrapper'}>{t('сlient_agreement')}{' '}
              <NavLink
                onClick={closeModal}
                rel={'noopener noreferrer'}
                target={'_blank'}
                to={common.getUrlByTemplate('agreement')}
              >
                {t('client_agreement_processingOfPersonalData')}
              </NavLink>
            </span>}
          name={'agreement'}
        />
      </div>
      <RenderButton
        className={'fill'}
        label={t('btn_waiting_call')}
        type={'submit'}
      />
      <p className={'required_fields'}>{t('client_required_fields')}</p>
    </form>);
};

export default reduxForm({
  form:         'NotificationForm',
  validate,
  onSubmitFail: (errors, dispatch) => {
  },
})(NotificationForm);
